const SMALL_BREAKPOINT = 500;
const MEDIUM_BREAKPOINT = 699;

export const color = {
  gray20: '#D3D3D3',
  gray40: `#B2B2B2`,
  gray80: '#505050',
  gray100: '#1A1A1A',
  teal20: '#B8E6E4',
  teal80: '#1CB0A8',
  teal100: '#E8F7F6',
  coral80: '#EF4056',
  coral100: '#8F2634',
  white100: '#FFFFFF',
  mint100: '#397C5B',

  facebook50: '#3C5A99',
  facebook100: '#2C4372',
  twitter50: '#1DA1F3',
  twitter100: '#0B85D0',

  // Tracking these here, so at least we can see them all in one place
  // for a better refactor later on.
  // Please check w design that there's no existing alias before adding.
  oneoff: {
    pocketHitsSubmitHover: '#C12342'
  }
};

export const breakpoint = {
  atSmallWidth: `@media (max-width: ${SMALL_BREAKPOINT}px)`,
  atMediumWidth: `@media (max-width: ${MEDIUM_BREAKPOINT}px)`,

  oneOff: {
    togglePeristentActions: `@media (min-width: 969px)`,
  }
};

export const font = {
  DOYLE: `"Doyle", Helvetica, Arial, sans-serif`,
  GRAPHIK: `"Graphik Web", "Helvetica Neue", Helvetica, Arial, sans-serif`,
}

export const socialLinks = {
  facebook: "https://www.facebook.com/pocket",
  twitter: "https://twitter.com/Pocket",
  linkedin: "https://www.linkedin.com/company/pocket-formerly-read-it-later-/",
}

export default {
  socialUtmCodes: {
    "FB": "fbsynd",
    "TWITTER": "twtrsynd",
    "EMAIL": "emailsynd",
  },
}
